// // 交叉观察器API之图片懒加载
// export default {
// 	inserted(el, binding) {

// 		const options = {
// 			root: null, // 使用视口作为根
// 			threshold: 0.1 // 当至少 10% 的元素在视口中时触发回调
// 		};
// 		const observer = new IntersectionObserver((entries, observer) => {
// 			entries.forEach(entry => {
// 				if (entry.isIntersecting) {
// 					const img = entry.target;
// 					img.src = binding.value;
// 					observer.unobserve(img)
// 				}

// 			});
// 		}, options);
// 		observer.observe(el);
// 	},
// 	unbind(el) {
// 		if (el._observer) {
// 			el._observer.disconnect(); // 取消监听
// 			delete el._observer;
// 		}
// 	}
// };


// 图片懒加载指令 - 极致优化版
export default {
	// 支持Vue2/Vue3
	inserted: initLazyLoad,
	mounted: initLazyLoad,
	// 指令更新时处理（新增）
	update: updateLazyLoad,
	// 解绑/卸载时清理
	unbind: stopObserve,
	unmounted: stopObserve
};

// 🌟 性能优化：复用IntersectionObserver实例，避免每个图片创建新实例
let globalObserver = null;
// 存储观察的元素和对应配置
const observerMap = new WeakMap();

/**
 * 获取全局共享的IntersectionObserver实例
 */
function getGlobalObserver() {
	if (!globalObserver) {
		const options = {
			root: null,
			rootMargin: '200px 0px', // 进一步提前加载，体验更优
			threshold: 0
		};

		globalObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				const img = entry.target;
				const {
					imgUrl,
					placeholder
				} = observerMap.get(img) || {};
				if (entry.isIntersecting && imgUrl) {
					// 执行图片加载逻辑
					loadImage(img, imgUrl, placeholder);
					// 加载后取消观察当前元素
					globalObserver.unobserve(img);
					observerMap.delete(img);
				}
			});
		}, options);
	}
	return globalObserver;
}

/**
 * 图片加载核心逻辑（抽离为纯函数）
 * @param {HTMLImageElement} img 图片元素
 * @param {string} imgUrl 真实图片地址
 * @param {string} placeholder 占位图地址
 */
function loadImage(img, imgUrl, placeholder) {
	// 避免重复加载
	if (img.src === imgUrl) return;

	// 创建临时Image对象预加载，避免直接修改img.src导致的布局抖动
	const tempImg = new Image();
	tempImg.src = imgUrl;

	// 预加载成功
	tempImg.onload = () => {
		// 平滑过渡（新增样式优化）
		img.style.opacity = '0';
		img.src = imgUrl;
		// 过渡动画
		setTimeout(() => {
			img.style.opacity = '1';
			img.style.transition = 'opacity 0.3s ease';
		}, 10);
		// 清理事件
		tempImg.onload = null;
		tempImg.onerror = null;
	};

	// 预加载失败
	tempImg.onerror = () => {
		img.src = placeholder;
		console.warn(`[懒加载] 图片加载失败: ${imgUrl}`);
		// 清理事件
		tempImg.onload = null;
		tempImg.onerror = null;
	};

	// 兜底清理：防止事件泄漏
	img._lazyTempImg = tempImg;
}

/**
 * 初始化懒加载
 * @param {HTMLElement} el 指令绑定的元素
 * @param {Object} binding 指令绑定值
 */
function initLazyLoad(el, binding) {
	// 1. 严格校验
	if (el.tagName.toLowerCase() !== 'img') {
		console.warn('[懒加载] v-datasrc 仅支持img标签');
		return;
	}
	const imgUrl = binding.value?.trim();
	if (!imgUrl || !/^https?:\/\/|^\/|^\./.test(imgUrl)) {
		console.warn('[懒加载] 无效的图片地址:', binding.value);
		return;
	}

	// 2. 存储占位图和真实地址
	const placeholder = el.src;
	observerMap.set(el, {
		imgUrl,
		placeholder
	});

	// 3. 复用全局观察器，性能提升N倍
	const observer = getGlobalObserver();
	observer.observe(el);

	// 4. 初始化样式（避免加载闪烁）
	el.style.opacity = '1';
	el.style.transition = 'opacity 0.3s ease';
}

/**
 * 指令更新时处理（比如图片地址变化）
 * @param {HTMLElement} el 元素
 * @param {Object} binding 新的绑定值
 */
function updateLazyLoad(el, binding) {
	// 地址未变化则不处理
	if (binding.value === binding.oldValue) return;

	// 取消旧的观察
	if (globalObserver) {
		globalObserver.unobserve(el);
		observerMap.delete(el);
	}

	// 清理临时图片
	if (el._lazyTempImg) {
		el._lazyTempImg.onload = null;
		el._lazyTempImg.onerror = null;
		delete el._lazyTempImg;
	}

	// 重新初始化
	initLazyLoad(el, binding);
}

/**
 * 停止观察并清理所有资源
 * @param {HTMLElement} el 元素
 */
function stopObserve(el) {
	// 1. 取消全局观察器的监听
	if (globalObserver) {
		globalObserver.unobserve(el);
		observerMap.delete(el);
	}

	// 2. 清理临时图片和事件
	if (el._lazyTempImg) {
		el._lazyTempImg.onload = null;
		el._lazyTempImg.onerror = null;
		delete el._lazyTempImg;
	}

	// 3. 清理元素样式和属性
	if (el.tagName.toLowerCase() === 'img') {
		el.style.opacity = '';
		el.style.transition = '';
		delete el.dataset.placeholder;
	}

	// 4. 当没有任何元素被观察时，销毁全局观察器（极致内存优化）
	if (globalObserver && observerMap.size === 0) {
		globalObserver.disconnect();
		globalObserver = null;
	}
}